<template>
  <el-row style="margin: 12px 0;align-items: center;">
    <el-col :span="12" class="propsLeft">{{ label }}</el-col>
    <el-col :span="12" class="propsRight">
      <el-switch v-model="innerVisible" @change="changeVisible"></el-switch>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    blendMode: {
      type: String
    }
  },
  data () {
    return {
      innerVisible: false
    }
  },
  watch: {
    visible (val) {
      this.innerVisible = val
    }
  },
  computed: {
  },
  methods: {
    changeVisible () {
      this.$emit('change', {
        id: this.id,
        valueProp: 'visible',
        value: this.innerVisible
      })
    }
  },
  mounted () {
    this.innerVisible = this.visible
  }
}
</script>
